// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/loader-white.gif", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup {
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  height: 100%;
  width: 100%;
  left: 50%;
  top: 0;
  max-width: 420px;
  transform: translate(-50%, 0);
  display: flex;
  align-items: center;
  z-index: 10;
}
.popup .loading {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
}
.popup .loading * {
  visibility: hidden;
}
.popup .overflow {
  width: 100%;
  max-height: 100%;
  overflow-y: auto;
}
.popup .box {
  background-color: #fff;
  border-radius: 5px;
  /*width: 88%;*/
  width: 320px;
  margin: 30px auto;
}
.popup .box .close {
  position: absolute;
  display: block;
  height: 15px;
  width: 15px;
  right: 20px;
  top: 20px;
  text-decoration: none;
  /*
  transform: rotate(45deg);
  border-color: #caa36c;


  &:before,
  &:after {
      transform: translate(-50%, -50%);
      position: absolute;
      content: "";
      left: 50%;
      top: 50%;
  }

  &:before {
      height: 100%;
      border-left: 2px solid #caa36c;
      border-color: inherit;
  }

  &:after {
      width: 100%;
      border-bottom: 2px solid #caa36c;
      border-color: inherit;
  }
  */
}
.popup .box .close span {
  font-size: 15px;
}`, "",{"version":3,"sources":["webpack://./src/components/admin/popups/Popup.scss"],"names":[],"mappings":"AAAA;EACI,oCAAA;EACA,eAAA;EACA,YAAA;EACA,WAAA;EACA,SAAA;EACA,MAAA;EACA,gBAAA;EACA,6BAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AACJ;AACI;EACI,2EAAA;AACR;AACQ;EACI,kBAAA;AACZ;AAGI;EACI,WAAA;EACA,gBAAA;EACA,gBAAA;AADR;AAII;EACI,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,YAAA;EACA,iBAAA;AAFR;AAIQ;EACI,kBAAA;EACA,cAAA;EACA,YAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,qBAAA;EAKA;;;;;;;;;;;;;;;;;;;;;;;;;GAAA;AAmBZ;AAvBY;EACI,eAAA;AAyBhB","sourcesContent":[".popup {\n    background-color: rgba(0, 0, 0, 0.5);\n    position: fixed;\n    height: 100%;\n    width: 100%;\n    left: 50%;\n    top: 0;\n    max-width: 420px;\n    transform: translate(-50%, 0);\n    display: flex;\n    align-items: center;\n    z-index: 10;\n\n    .loading {\n        background: url(../../../../public/images/loader-white.gif) no-repeat center center;\n        \n        * {\n            visibility: hidden;\n        }\n    }\n\n    .overflow{\n        width: 100%;\n        max-height: 100%;\n        overflow-y: auto;\n    }\n\n    .box {\n        background-color: #fff;\n        border-radius: 5px;\n        /*width: 88%;*/\n        width: 320px;\n        margin: 30px auto;\n\n        .close {\n            position: absolute;\n            display: block;\n            height: 15px;\n            width: 15px;\n            right: 20px;\n            top: 20px;\n            text-decoration: none;\n            span{\n                font-size: 15px;\n            }\n\n            /*\n            transform: rotate(45deg);\n            border-color: #caa36c;\n\n\n            &:before,\n            &:after {\n                transform: translate(-50%, -50%);\n                position: absolute;\n                content: \"\";\n                left: 50%;\n                top: 50%;\n            }\n\n            &:before {\n                height: 100%;\n                border-left: 2px solid #caa36c;\n                border-color: inherit;\n            }\n\n            &:after {\n                width: 100%;\n                border-bottom: 2px solid #caa36c;\n                border-color: inherit;\n            }\n            */\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
